export default __webpack_public_path__ + "static/media/wedding-party-register-step-2-background.34068192.jpg";